import { Component } from '@angular/core';
import { BaseComponent } from '@components/base/base.component';
import { ContentTiles } from '@interfaces/content-tiles.interface';

@Component({
  selector: 'app-why-byt',
  templateUrl: './why-byt.component.html',
  styleUrls: ['./why-byt.component.less']
})
export class WhyBytComponent extends BaseComponent {
  public tiles: ContentTiles[] = [
    {
      title: 'byt_home_why_byt_title_1',
      image:
        'https://admin.bookyourtrail.com/assets/4e3e8c1a-7a18-4d32-877c-a992b235eb82.jpg',
      url: `${this.siteSettings.links[this.currLang]?.byt}`
    },
    {
      title: 'byt_home_why_byt_title_2',
      image:
        'https://admin.bookyourtrail.com/assets/4e81f48b-ee27-4b4e-981f-4142822af590.jpg',
      url: `${this.siteSettings.links[this.currLang]?.support}`
    }
  ];
}
